import { render, staticRenderFns } from "./AudioVideoDialogue.vue?vue&type=template&id=6ef7eb06&scoped=true&"
import script from "./AudioVideoDialogue.vue?vue&type=script&lang=js&"
export * from "./AudioVideoDialogue.vue?vue&type=script&lang=js&"
import style0 from "./AudioVideoDialogue.vue?vue&type=style&index=0&id=6ef7eb06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef7eb06",
  null
  
)

export default component.exports